import sequence from 'utils/sequence';

/**
 * Types
 */

const INITIAL_STATE = {
  growls: [],
  error: {},
  loaders: [],
};

export const Types = {
  GROWL_ADDED: 'ui/GROWL_ADDED',
  GROWL_REMOVED: 'ui/GROWL_REMOVED',
  SHOW_LOADER: 'ui/SHOW_LOADER',
  HIDE_LOADER: 'ui/HIDE_LOADER',
};

/**
 * Helpers
 */
const hideAllGrowls = growls => growls.map(g => ({ ...g, hidden: true }));
const hideGrowl = (target, growls) => growls.map(g => (g === target ? { ...g, hidden: true } : g));
export const getGrowls = state => state.ui.growls;

/**
 * Reducer
 */
export default function Ui(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GROWL_ADDED:
      return {
        ...state,
        growls: [...hideAllGrowls(state.growls), action.payload.message],
        error: action.payload.error,
      };
    case Types.GROWL_REMOVED:
      return {
        ...state,
        growls: hideGrowl(action.payload, state.growls),
      };
    case Types.SHOW_LOADER: {
      const loaders = state.loaders.includes(action.payload)
        ? state.loaders
        : [...state.loaders, action.payload];
      return {
        ...state,
        loaders,
      };
    }
    case Types.HIDE_LOADER: {
      return {
        ...state,
        loaders: state.loaders.filter(l => l !== action.payload),
      };
    }
    default:
      return state;
  }
}

/**
 * Constants
 */
export const growlTypes = {
  GROWL_INFO: 'GROWL_INFO',
  GROWL_ERROR: 'GROWL_ERROR',
  GROWL_SUCCESS: 'GROWL_SUCCESS',
};

const idSeq = sequence();

/**
 * Actions Creators
 */
export const Creators = {
  growl: (message, type = growlTypes.GROWL_INFO, error) => {
    const payload = {
      message: {
        type,
        message,
        id: idSeq.next(),
      },
      error,
    };
    return {
      type: Types.GROWL_ADDED,
      payload,
    };
  },
  removeGrowl: payload => ({
    type: Types.GROWL_REMOVED,
    payload,
  }),
  showLoader: payload => ({ type: Types.SHOW_LOADER, payload }),
  hideLoader: payload => ({ type: Types.HIDE_LOADER, payload }),
};
